import { render, staticRenderFns } from "./corporate-branch-list.vue?vue&type=template&id=5c5399f9&scoped=true&"
import script from "./corporate-branch-list.vue?vue&type=script&lang=js&"
export * from "./corporate-branch-list.vue?vue&type=script&lang=js&"
import style0 from "./corporate-branch-list.vue?vue&type=style&index=0&id=5c5399f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5399f9",
  null
  
)

export default component.exports